<template>
	<div class="body">

		<div class="body-container">
			<!-- 左侧box -->
			<div class="left-box" v-if="rankData">
				<div class="box-header header-border" @click="clickRoute(rankData.more)">
					<span class="title-text">{{rankData.name}}</span>
					<img class="line-pic" src="../assets/icons/bord_line.png" />
				</div>
				<div class="box-body">
					<img class="map" :src="rankData.list.top.images" @click="clickRoute(rankData.list.top)"/>
					<div class="link-box1">
						<div class="link-row link-row-margin1" v-for="(item, index) in rankData.list.list" :key="index"
							@click="clickRoute(item)">
							<img class="point-pic" src="../assets/icons/circle_point.png" />
							<div class="link nowrap">{{ item.title }}</div>
						</div>
					</div>
				</div>
				<div class="box-bottom" v-if="rankData.list.bottom" @click="clickRoute(rankData.list.bottom)">
					<img class="point-pic" src="../assets/icons/circle_point.png" />
					<div class="link nowrap">{{ rankData.list.bottom.title }}</div>
				</div>
			</div>

			<!-- 右侧box -->
			<div class="right-box" v-if="matrixData">
				<div class="box-header header-border" @click="clickRoute(matrixData.more)">
					<span class="title-text">{{matrixData.name}}</span>
					<div class="more-container">
						<span class="more-text">{{matrixData.more.name}}</span>
						<img class="more-icon" src="../assets/icons/arrow_right.png" />
					</div>
				</div>
				<div class="box-body">
					<div>
						<div class="link-row link-row-margin2" v-for="(item, index) in matrixData.list" :key="index"
							@click="clickRoute(item)">
							<img class="point-pic" src="../assets/icons/circle_point.png" />
							<div class="link nowrap">{{ item.title }}</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 平台咨询 -->
		<div class="horizontal-box" v-if="msgList">
			<img class="advice-slogan" src="../assets/seek_advice.png" />
			<!-- <div class="messages"></div> -->
			<el-carousel class="advice-msgs" direction="vertical" :autoplay="true">
				<el-carousel-item v-for="(item, index) in msgList" :key="index">
					<span class="msg-text" @click="clickRoute(item)">{{ item.title }}</span>
				</el-carousel-item>
			</el-carousel>
		</div>

		<div class="body-container" v-if="serviceData">
			<!-- 左侧box -->
			<div class="left-box">
				<div class="box-header header-border" @click="clickRoute(serviceData.more)">
					<span class="title-text">{{serviceData.name}}</span>
					<img class="line-pic" src="../assets/icons/bord_line.png" />
				</div>
				<div class="box-body">
	<!-- 				<div class="sci-res-left">
						<div class="service-title">{{serviceData.map.edu_data.name}}</div>
						<div class="pics-area">
							<img class="pic" v-for="(item, index) in serviceData.map.edu_data.list" :key="index" :src="item.images"
								mode="aspectFill" @click="clickRoute(item)"/>
						</div>
					</div> -->
					<div class="sci-res-right">
						<div class="service-title">{{serviceData.map.thesis.name}}</div>
						<div class="thesis-group" v-for="(group, index) in serviceData.map.thesis.list" :key="index">
							<div class="thesis-group-name">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{group.name}}</div>
							<div class="thesis-item" v-for="(item, index2) in group.list" :key="index2" @click="clickRoute(item)">
								&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
								<img class="point-pic" src="../assets/icons/circle_point.png" />
								<div class="thesis-item-name nowrap">{{ item.title }}</div>
							</div>
						</div>
					</div>
					
					<div class="img-ctr">
						<img src="http://syzsoss.oss-cn-chengdu.aliyuncs.com/202509/19145457-52696317484840950.png" class="service-img"/>
					</div>
				</div>
			</div>

			<!-- 右侧box -->
			<div class="right-box" v-if="policyData">
				<div class="box-header header-border" @click="clickRoute(policyData.more)">
					<span class="title-text">{{policyData.name}}</span>
					<div class="more-container" >
						<span class="more-text" >{{policyData.more.name}}</span>
						<img class="more-icon" src="../assets/icons/arrow_right.png" />
					</div>
				</div>
				<div class="box-body">
					<div>
						<div class="policy-group" v-for="(group, index) in policyData.list" :key="index">
							<div class="group-title-container">
								<div class="group-title">{{ group.name }}</div>
								<img class="group-icon" src="../assets/icons/riangle_red.png" />
							</div>
							<div class="papers">
								<div class="paper-item" v-for="(paper, index2) in group.list" :key="index2" @click="clickRoute(paper)">
									<img class="point-pic" src="../assets/icons/circle_point.png" />
									<div class="paper-name nowrap">{{ paper.title }}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="body-container" v-if="collegeData">
			<!-- 左侧box -->
			<div class="left-box">
				<div class="box-header header-border" @click="clickRoute(collegeData.more)">
					<span class="title-text">{{collegeData.name}}</span>
					<img class="line-pic" src="../assets/icons/bord_line.png" />
				</div>
				<div class="box-body">
					<div>
						<div class="college-brif">
							<div class="college-groups">
								<span class="group-name" v-for="(group, index) in collegeData.list" :key="index"
									:class="{'active-group': activeCollegeGroup == index}"
									@click="changeCollegeGroup(index)">{{ group.name }}</span>
							</div>
							<el-carousel class="carousel"
								type="card" arrow="always" indicator-position="none">
								<el-carousel-item v-for="(item, index) in collegeData['list'][activeCollegeGroup].list"
									:key="index">
									<img class="college-img" :src="item.images" @click="clickRoute(item)"/>
								</el-carousel-item>
							</el-carousel>
							<div class="customize-tips">图片更换联系在线客服</div>
						</div>
					</div>
				</div>
			</div>

			<!-- 右侧box -->
			<div class="right-box" v-if="videoData">
				<div class="box-header header-border" @click="clickRoute(videoData.more)">
					<span class="title-text">{{videoData.name}}</span>
					<div class="more-container">
						<span class="more-text">{{videoData.more.name}}</span>
						<img class="more-icon" src="../assets/icons/arrow_right.png" />
					</div>
				</div>
				<div class="box-body">
					<div class="expert-videos">
						<div class="expert-voice" v-for="(video, index) in videoData.list" :key="index" @click="clickRoute(video)">
							<img class="expert-img" :src="video.images" />
							<div class="expert-title">{{ video.title }}</div>
						</div>
						<div class="customize-tips">定制化讲座请联系客服</div>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import {
		getIndex
	} from "@/api/index"
	
	import {
		parse,handleProtocal,handleRouteProtocal
	} from "@/utils/protocal"

	export default {
		name: "Index",
		data() {
			return {
				rankData: null,
				matrixData: null,
				serviceData: null,
				policyData: null,
				collegeData: null,
				activeCollegeGroup: 0,
				videoData: null,
				msgList: null,
			}
		},
		created() {
			this.initPageData();
		},
		methods: {
			initPageData() {	
				getIndex().then(res => {
					this.rankData = res.data.contentData.rank;
					this.matrixData = res.data.contentData.matrix;					
					this.serviceData = res.data.contentData.service;
					this.policyData = res.data.contentData.policy;
					this.collegeData = res.data.contentData.college;
					this.videoData = res.data.contentData.video;
					this.msgList = res.data.msgList;
				});
			},

			clickRoute(item) {
				console.log('item', item)
				let data = parse(item.url)
				
				if(data['head'] == 'replace'){
					let url = "/" + data['path'];
					if (data['data'] != null && data['data'].length != 0) {
						url += "?" + data['data'];
					}
					console.log('url', url)
					// this.$router.replace(url);
					this.$router.push(url);
				}else{
					handleRouteProtocal(data)
				}
			},

			changeCollegeGroup(index) {
				this.activeCollegeGroup = index;
			},

		}
	}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	@use "index.scss";
</style>